import {get} from "lodash"
import supported from "./supported.json"
import transformLocale from "./transformLocale"
import makeOptions from "./getSupportedLocaleOptions"
import getDeviceLocale from "./getDeviceLocale"

export {makeOptions}
export const DEFAULT_LANG = "en-GB"

/** @author: Richard Scoones
 *  @desc: As lang files are stored remotely We need to make sure we only make requests for languages we currently support.
 *         This file will allow for optional dialect's but request base lanauge if not supported.
 */
export default (rawLocale = getDeviceLocale()): string => {
  const locale = transformLocale(rawLocale || getDeviceLocale())
  const [language] = locale.split("-")

  const foundDialect = get(supported, `${language}.${locale}`)
  if (foundDialect) {
    return locale
  }

  // if we can find the lanuage, use the default Dialect
  const foundLanguage = get(supported, `${language}`)
  if (foundLanguage) {
    return foundLanguage.default
  }

  if (typeof global !== "undefined" && !global.__IS_TEST__) {
    console.warn(`[Content]: "${locale}" not supported, default to "${DEFAULT_LANG}"`)
  }
  return DEFAULT_LANG
}
